import { Injectable } from "@angular/core";
// eslint-disable-next-line import/no-extraneous-dependencies
import { cloneDeep } from "lodash";
import { Viewerlayer } from "../../model/viewerlayer";

@Injectable({
  providedIn: "root",
})
export class FeaturesSearchService {
  private _layers: any[];

  private _filteredLayers: any[];

  private fieldFilter: string = "";

  private layerFilter: string = "";

  private searchFilter: string = null;

  private featureProperties: Set<any>;

  private layersNames: Set<any>;

  get filteredLayers() {
    return this._filteredLayers;
  }

  set filteredLayers(layers) {
    this._filteredLayers = layers;
  }

  get layers() {
    return this._layers;
  }

  set layers(layers) {
    this._layers = layers;
  }

  setLayers(layers) {
    this.layers = layers;
    this.filteredLayers = cloneDeep(layers);
  }

  getProperties(): Set<any> {
    return this.featureProperties;
  }

  setPropertiesFromFeatures() {
    const properties = new Set();
    this.filteredLayers.forEach((l) => {
      if (l.customOverlayProperties)
        l.customOverlayProperties.layerProperties.forEach((p) => {
          properties.add(p);
        });
      else if (l.source?.features && l.source.features.features?.length > 0)
        Object.keys(l.source.features.features[0].properties).forEach((p) => {
          properties.add(p);
        });
    });

    this.featureProperties = properties;
  }

  getLayersNames(): Set<any> {
    return this.layersNames;
  }

  setLayersNamesFromFeatures() {
    const layersNames = new Set();
    this.filteredLayers.forEach((l) => {
      layersNames.add(l.name);
    });
    this.layersNames = layersNames;
  }

  restartFilters(layers: Viewerlayer[]): void {
    this.searchFilter = "";
    this.fieldFilter = "";
    this.layerFilter = "";
    this.setLayers(layers);
  }

  filterUserLayersBySearch(location: string): Viewerlayer[] {
    this.searchFilter = location;

    this.filterUserLayersByLayer(this.layerFilter);

    this.filterUserLayersByField(this.fieldFilter);

    return this.filteredLayers;
  }

  filterUserLayersByLayer(layer: string): Viewerlayer[] {
    this.setLayers(this.layers);
    this.layerFilter = layer;
    this.filterSearchFeatures(this.searchFilter);
    this.filterLayerFeatures(layer);
    this.setPropertiesFromFeatures();
    this.filterFieldsFeatures(this.fieldFilter);
    if (!layer) this.setLayersNamesFromFeatures();

    return this.filteredLayers;
  }

  filterUserLayersByField(field: string): Viewerlayer[] {
    this.setLayers(this.layers);
    this.fieldFilter = field;
    this.filterSearchFeatures(this.searchFilter);
    this.filterFieldsFeatures(field);
    this.setLayersNamesFromFeatures();
    this.filterLayerFeatures(this.layerFilter);
    if (!field) this.setPropertiesFromFeatures();

    return this.filteredLayers;
  }

  private filterSearchFeatures(value: string): Viewerlayer[] {
    if (value)
      this.filteredLayers = this.filteredLayers.filter((l) => {
        if (l.source?.features)
          l.source.features.features = l.source.features.features.filter((f) => {
            let hasProperty = false;
            if (l.customOverlayProperties)
              l.customOverlayProperties.layerProperties.forEach((lp) => {
                if (!hasProperty && f.properties[lp])
                  // No case sensitive
                  hasProperty = f.properties[lp].toString().toLowerCase().includes(value.toLowerCase());
              });
            else {
              Object.values(f.properties).forEach((valueProperty) => {
                if (!hasProperty && valueProperty)
                  // No case sensitive
                  hasProperty = valueProperty.toString().toLowerCase().includes(value.toLowerCase());
              });
            }
            return hasProperty;
          });

        return !!l.source?.features && l.source.features.features?.length > 0;
      });

    return this.filteredLayers;
  }

  private filterLayerFeatures(layer: string): Viewerlayer[] {
    if (layer) this.filteredLayers = this.filteredLayers.filter((l) => l.name.includes(layer));
    return this.filteredLayers;
  }

  private filterFieldsFeatures(field: string): Viewerlayer[] {
    if (field)
      this.filteredLayers = this.filteredLayers.filter((l) => {
        return (
          (l.customOverlayProperties && l.customOverlayProperties.layerProperties.includes(field)) ||
          (l.source?.features &&
            l.source.features.features[0] &&
            Object.keys(l.source.features.features[0].properties).includes(field))
        );
      });
    return this.filteredLayers;
  }
}
